const WINE_TYPES = ['blanco', 'orange', 'tinto', 'rosado', 'petnat'];

const TYPE_ALIASES = {
  blanco: 'blanco',
  white: 'blanco',
  blanc: 'blanco',
  orange: 'orange',
  naranja: 'orange',
  amber: 'orange',
  tinto: 'tinto',
  red: 'tinto',
  rouge: 'tinto',
  rosado: 'rosado',
  rose: 'rosado',
  rosé: 'rosado',
  clarete: 'rosado',
  petnat: 'petnat',
  'pet nat': 'petnat',
  'pet-nat': 'petnat',
  petillant: 'petnat',
};

const clamp = (value, min, max) => Math.min(max, Math.max(min, value));

const hashToRange = (seed, min, max) => {
  const text = String(seed ?? '');
  let hash = 0;
  for (let i = 0; i < text.length; i += 1) {
    hash = (hash * 31 + text.charCodeAt(i)) >>> 0;
  }
  const span = max - min;
  return min + (hash % (span + 1));
};

export const normalizeWineType = (raw) => {
  if (!raw) return null;
  const key = String(raw)
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim();
  return TYPE_ALIASES[key] || null;
};

export const getWineType = (item) => {
  const fromApi = normalizeWineType(
    item?.wineType || item?.wine_type || item?.color || item?.colour || item?.type
  );
  if (fromApi && WINE_TYPES.includes(fromApi)) return fromApi;

  const name = String(item?.name || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');

  if (name.includes('petnat') || name.includes('pet nat') || name.includes('pet-nat') || name.includes('petillant')) {
    return 'petnat';
  }
  if (name.includes('orange') || name.includes('naranja')) return 'orange';
  if (name.includes('tinto') || name.includes('negre') || name.includes('rouge')) return 'tinto';
  if (name.includes('blanco') || name.includes('white') || name.includes('blanc')) return 'blanco';
  if (name.includes('rosado') || name.includes('rose') || name.includes('clarete') || name.includes('rosat')) {
    return 'rosado';
  }
  return 'blanco';
};

export const getWinePosition = (item) => {
  // Acidez: escala 1-5 (barra de 5 segmentos, como el funk pero para acidez).
  const acidityRaw = item?.acidity ?? item?.acidez;
  const hasAcidity = acidityRaw !== undefined && acidityRaw !== null && acidityRaw !== '';
  const acidity = hasAcidity
    ? clamp(Math.round(Number(acidityRaw)), 1, 5)
    : hashToRange(`${item?.id}-acidity`, 2, 4);

  // Cuerpo/intensidad: se mantiene en escala 0-100 (se traduce a texto: Ligero/Medio/Con cuerpo).
  const intensityRaw = item?.intensity ?? item?.intensidad;
  const hasIntensity = intensityRaw !== undefined && intensityRaw !== null && intensityRaw !== '';
  const intensity = hasIntensity
    ? clamp(Number(intensityRaw), 0, 100)
    : hashToRange(`${item?.id}-intensity`, 12, 88);

  return { acidity, intensity };
};

// El funk se carga en el admin como un numero libre de 0 a 100 (mas facil de
// tipear/afinar), pero en pantalla siempre se muestra como 4 rayos ⚡, asi
// que acá lo convertimos a un nivel 1-4.
const bucket4 = (value) => {
  if (value >= 75) return 4;
  if (value >= 50) return 3;
  if (value >= 25) return 2;
  return 1;
};

export const getFlavorBars = (item) => {
  const aromasRaw = item?.aromas;
  const funkinessRaw = item?.funkiness ?? item?.funk;
  const aromas = aromasRaw !== undefined && aromasRaw !== null && aromasRaw !== ''
    ? clamp(Math.round(Number(aromasRaw)), 1, 4)
    : 2;
  const funkiness = funkinessRaw !== undefined && funkinessRaw !== null && funkinessRaw !== ''
    ? bucket4(clamp(Number(funkinessRaw), 0, 100))
    : 2;
  return { aromas, funkiness };
};

export const WINE_TYPE_FILTERS = [
  { id: 'all', label: 'Todos' },
  { id: 'blanco', label: 'Blanco' },
  { id: 'orange', label: 'Orange' },
  { id: 'tinto', label: 'Tinto' },
  { id: 'rosado', label: 'Rosado' },
  { id: 'petnat', label: 'Pet Nat' },
];
